<template>
  <div class="root" @keyup.enter="handleSaveClick()">
    <form ref="pipelineMainLpg" class="pump-form">
      <custom-input
        required
        inputType="text"
        placeholder="Название"
        labelText="Название"
        v-model="model.name"
        :errorMessage="validator['name']"
        :inputValue="model.name"
        name="name"
      />

      <main-select
        class="create-form-item"
        label="Содержимое вещество"
        id="substance-select"
        v-model="model.substance"
        :options="substancesOptions"
        placeholder="Выберите вещество"
        :clearable="false"
        isRequired
        :errorMessage="validator['substance']"
        :inputId="'substance'"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Температура вещества в аппарате, С"
        labelText="Температура вещества в аппарате, С"
        v-model="model.T"
        :errorMessage="validator['T']"
        :inputValue="model.T"
        name="T"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Внутренний радиус, м"
        labelText="Внутренний радиус, м"
        v-model="model.R"
        :errorMessage="validator['R']"
        :inputValue="model.R"
        name="R"
      />

      <div class="input-groupe">
        <custom-input
          required
          inputType="number"
          placeholder="Длина, м"
          labelText="Длина, м"
          v-model="model.L"
          :errorMessage="validator['L']"
          :inputValue="model.L"
          name="L"
          id="L"
          tooltipValue="Вы можете ввести длину трубопровода вручную или выбрать автоматический расчет, что бы программа сама определила длину"
          :disabled="Boolean(model.autoL)"
        />
        <custom-checkbox
          class="form-checkbox"
          :value="Boolean(model.autoL)"
          @input="handleCheckboxChange"
          labelText="Автоматический расчет"
        />
      </div>

      <custom-input
        required
        inputType="number"
        placeholder="Давление в аппарате, кПа"
        labelText="Давление в аппарате, кПа"
        v-model="model.P"
        :errorMessage="validator['P']"
        :inputValue="model.P"
        name="P"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Время аварийного отключения, с"
        labelText="Время аварийного отключения, с"
        v-model="model.shutdown"
        :errorMessage="validator['shutdown']"
        :inputValue="model.shutdown"
        name="shutdown"
      />

      <main-select
        class="create-form-item"
        label="Система пожаротушения"
        id="extinguish-system"
        v-model="model.extinguish_system"
        :options="extinguishOptions"
        placeholder="Система пожаротушения"
        :clearable="false"
        isRequired
        :errorMessage="validator['extinguish_system']"
        :searchable="false"
      />

      <main-select
        class="create-form-item"
        label="Система сигнализации"
        id="alarm-system"
        v-model="model.alarm_system"
        :options="alarmOptions"
        placeholder="Система пожаротушения"
        :clearable="false"
        isRequired
        :errorMessage="validator['alarm_system']"
        :searchable="false"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Коэффициент разлития"
        labelText="Коэффициент разлития"
        v-model="model.f"
        :errorMessage="validator['f']"
        :inputValue="model.f"
        name="f"
        tooltipValue="При отсутствии данных допускается принимать равным 20 * при проливе на грунтовое покрытие, 150 * при проливе на бетонное или асфальтовое покрытие"
      />

      <custom-checkbox class="create-form-item" labelText="Подземный" v-model="model.underground" />

      <custom-input
        required
        inputType="number"
        placeholder="Толщина стенки, мм"
        labelText="Толщина стенки, мм"
        v-model="model.wallThickness"
        :errorMessage="validator['wallThickness']"
        :inputValue="model.wallThickness"
        name="wallThickness"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Минимальная глубина заложения, м"
        labelText="Минимальная глубина заложения, м"
        v-model="model.depthOfLaying"
        :errorMessage="validator['depthOfLaying']"
        :inputValue="model.depthOfLaying"
        name="depthOfLaying"
      />

      <main-select
        withReduce
        class="create-form-item"
        label="Участок выполненный методом наклонно направленного бурения"
        id="directionalDrilling"
        v-model="model.directionalDrilling"
        :options="[
          { code: 0, label: 'на участках этих переходов' },
          { code: 1, label: 'вне этих участков' },
        ]"
        placeholder=""
        :clearable="false"
        isRequired
        :errorMessage="validator['directionalDrilling']"
        :searchable="false"
      />

      <main-select
        withReduce
        class="create-form-item"
        label="Искуственные препятствия"
        id="artificialObstacles"
        v-model="model.artificialObstacles"
        :options="[
          { code: 2, label: 'на переходах через автодороги, железные дороги и инженерные коммуникации' },
          {
            code: 1,
            label:
              'вне переходов либо на них предусмотрены защитные футляры(кожухи) из стальных труб с герметизацией межтрубного пространства',
          },
        ]"
        placeholder="Искуственные препятствия"
        :clearable="false"
        isRequired
        :errorMessage="validator['artificialObstacles']"
        :searchable="false"
      />

      <main-select
        withReduce
        class="create-form-item"
        label="Материалы и средства контроля при строительстве"
        id="controlDuringConstruction"
        v-model="model.controlDuringConstruction"
        :options="[
          {
            code: 0.07,
            label:
              'Использованы улучшенные материалы и дополнительные средства контроля при строительстве и последующей эксплуатации',
          },
          {
            code: 1,
            label: 'Построен в соответствии с требованиями нормативных документов',
          },
        ]"
        placeholder=""
        :clearable="false"
        isRequired
        :errorMessage="validator['controlDuringConstruction']"
        :searchable="false"
      />

      <main-select
        withReduce
        class="create-form-item"
        label="Защита от коррозии"
        id="corrosionProtection"
        v-model="model.corrosionProtection"
        :options="[
          {
            code: 0.16,
            label: 'Использованы улучшенная система защиты',
          },
          {
            code: 1,
            label: 'Построен в соответствии с требованиями нормативных документов',
          },
        ]"
        placeholder="Защита от коррозии"
        :clearable="false"
        isRequired
        :errorMessage="validator['corrosionProtection']"
        :searchable="false"
      />

      <main-select
        withReduce
        class="create-form-item"
        label="Прохождение через водные преграды"
        id="waterObstacle"
        v-model="model.waterObstacle"
        :options="[
          { code: 5, label: 'Присутствуют водные преграды' },
          { code: 2, label: 'Присутствуют заболоченные участки' },
          { code: 1, label: 'Отсутствуют переходы либо выполнены методом наклонно направленного бурения' },
        ]"
        placeholder="Прохождение через водные преграды"
        :clearable="false"
        isRequired
        :errorMessage="validator['waterObstacle']"
        :searchable="false"
      />
    </form>
    <div class="form-button-block">
      <main-button :loading="saving" class="form-button" @click="handleSaveClick()">
        <span v-if="pipeline && pipeline.id">Сохранить</span>
        <span v-else>Создать</span>
      </main-button>

      <main-button @click="onCancelClick" color="link">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import "vue-form-generator/dist/vfg.css";
import Input from "../ui/Input.vue";
import MainButton from "../ui/MainButton.vue";
import MainSelect from "../ui/MainSelect.vue";
import CustomCheckbox from "../ui/Checkbox.vue";
import { EXTINGUISH_OPTIONS, SPILLAGE_COEFFICIENT } from "../../constants/constants";
import { baseMethods } from "../../views/risks/pipelines/baseMethods";
import { scrollToErrorInput } from "../../utils/utils.js";

export default {
  components: {
    "custom-input": Input,
    MainSelect,
    MainButton,
    CustomCheckbox,
  },
  props: {
    saving: Boolean,
    pipeline: Object,
    substances: Array,
    substance: Object,
    substrate: Object,
    type: [Number, String],
    validator: Object,
    loadSubstances: Function,
  },
  methods: {
    handleCheckboxChange() {
      this.model.autoL = this.model.autoL == 1 ? 0 : 1;
      if (this.model.autoL == 1) {
        this.model.S = this.getPipelineLength(this.pipeline.dots, this.substrate.k);
      }
    },
    onCancelClick() {
      this.$bvModal.hide("editPipeline");
    },

    validate() {
      this.$emit("update:validator", {});
      const errors = {};
      let isValid = true;
      const elementNames = [
        "substance",
        ...Array.from(this.$refs.pipelineMainLpg.elements)
          .map((element) => element.name)
          .filter((item) => Boolean(item)),
      ];
      elementNames.forEach((item) => {
        if (this.model[item] !== 0 && this.model[item] !== "0" && !this.model[item]) {
          isValid = false;
          errors[item] = "Необходимо заполнить поле";
        }
      });
      scrollToErrorInput(errors, this.$refs.pipelineMainLpg);
      this.$emit("update:validator", errors);
      return isValid;
    },

    handleSaveClick() {
      if (this.validate()) {
        this.$emit("create", this.model);
      }
    },
  },
  watch: {
    "model.autoL"() {
      if (this.model.autoL == 1) {
        this.model.L = this.getPipelineLength(this.pipeline.dots, this.substrate.k);
      }
    },
    type: function (val) {
      this.$set(this.model, "obj_type", val);
    },
    pipeline() {
      Object.assign(this.model, this.pipeline);
    },
    substance() {
      this.model.substance = { code: this.substance.id, label: this.substance.name };
    },
    substances() {
      this.substancesOptions = this.substances[0].subs.map((item) => {
        return { code: item.id, label: item.name };
      });
    },
    validator() {
      this.$set(this.model, "validator", this.validator);
    },
  },
  mixins: [baseMethods],
  mounted() {
    this.$set(this.model, "obj_type", this.type);

    // Тип 44 это жидкости
    if (this.type == 44) {
      this.loadSubstances(2);
    } else {
      this.loadSubstances(1);
    }

    if (this.pipeline.id) {
      Object.assign(this.model, this.pipeline);
      this.model.extinguish_system = this.extinguishOptions.find(
        (item) => item.code === Number(this.pipeline.extinguish_system)
      );
      this.model.alarm_system = this.alarmOptions.find((item) => item.code === Number(this.pipeline.alarm_system));
      this.model.underground = Boolean(Number(this.pipeline.underground));
      this.model.directionalDrilling = Number(this.pipeline.directionalDrilling);
      this.model.artificialObstacles = Number(this.pipeline.artificialObstacles);
      this.model.controlDuringConstruction = Number(this.pipeline.controlDuringConstruction);
      this.model.corrosionProtection = Number(this.pipeline.corrosionProtection);
      this.model.waterObstacle = Number(this.pipeline.waterObstacle);
    }
    if (this.model.autoL == 1) {
      if (typeof this.pipeline.dots === "string") {
        this.pipeline.dots = JSON.parse(this.pipeline.dots);
      }
      this.model.L = this.getPipelineLength(this.pipeline.dots, this.substrate.k);
    }
  },
  data() {
    return {
      substancesOptions: [],
      extinguishOptions: EXTINGUISH_OPTIONS,
      alarmOptions: [
        { code: 0, label: "Отсутствует" },
        { code: 0.8, label: "Присутствует" },
      ],
      spillageCoefficient: SPILLAGE_COEFFICIENT,

      model: {
        name: this.type == 44 ? "Магистральный трубопровод" : "Магистральный газопровод (СУГ)",
        obj_type: 45,
        substance: null,
        L: 1,
        R: 0.1,
        T: 37,
        P: null,
        f: 150,
        shutdown: 0,
        autoL: 1,
        wallThickness: 0,
        depthOfLaying: 0,
        directionalDrilling: 0,
        artificialObstacles: 1,
        controlDuringConstruction: 1,
        corrosionProtection: 1,
        waterObstacle: 1,
        underground: false,
        extinguish_system: { code: 0, label: "Отсутствует" },
        alarm_system: { code: 0, label: "Отсутствует" },
        validator: {},
      },
    };
  },
};
</script>

<style scoped>
.root {
  position: relative;
  padding: 0;
}
.pump-form {
  padding: 0 24px 32px;
}
.create-form-item {
  margin-bottom: 16px;
}

.input-groupe {
  margin-bottom: 16px;
}
</style>
